__turbopack_context__.v({
  "className": "merriweather_f986770a-module__4r1O5G__className",
});
